import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Alarm from '@material-ui/icons/Alarm';
import Error from '@material-ui/icons/Error';

import SelectInput from '../../inputs/SelectInput';

import { getTotalSecondsDiference } from '../../../functions/time';
import { BlueCloseIcon } from '../../../images/icons/WrapSvg';

class CommandPopup extends React.Component {
    state = {
        open: true,
        product: this.props.info ? this.props.info : {},
        machines: [],
        list: [],
        units: this.props.info ? this.props.info.cantidad : 1,
        enabled: this.props.info ? !this.props.info.preparando : false,
        totalTime: this.props.info.preparando
            ? this.props.info.nextrun
                ? getTotalSecondsDiference(this.props.info.nextrun, this.props.xef_reference_time)
                : 5
            : 0
    }

    UNSAFE_componentWillMount() {
        this.props.getMachinesProduct(this.props.id, this.state.product.idProducto).then((data) => {
            const { units, enabled } = this.state;
            this.UpdateMachines(
                data.filter((m) => m.estado === 3 || (enabled && m.estado === 4)),
                units,
                true,
            );
        });
    }

    UpdateMachines = (arr, units, timer) => {
        const temp = arr.reduce((arr, m) => {
            if (!m.rangos || m.rangos.length === 0) {
                arr.push(m);
            } else if (m.rangos.some((a) => a.desde <= units && a.hasta >= units)) {
                arr.push(m);
            }
            return arr;
        }, []);
        const aux = temp && temp.length > 0 ? temp[0] : {};
        const priotiaries = temp && temp.length > 0 ? temp.filter((f) => f.prioritaria) : {};
        const selected = priotiaries && priotiaries.length > 0 ? priotiaries[0] : aux;

        if (timer && selected.id && this.props.info.preparando) {
            const countdown = setInterval(this.timerInterval, 1000);
            this.setState({
                machines: arr,
                list: temp,
                machine: selected.id ? { value: selected.id, label: selected.nombre } : null,
                elapseTime: selected.id ? this.state.totalTime : undefined,
                countdown: countdown,
                loaded: true
            });
        } else {
            const { countdown } = this.state;
            if (countdown) {
                clearInterval(countdown);
            }

            this.setState({
                machines: arr,
                list: temp,
                machine: selected.id ? { value: selected.id, label: selected.nombre } : null,
                elapseTime: undefined,
                countdown: undefined,
                loaded: true
            });
        }
    };

    componentWillUnmount() {
        const { countdown } = this.state;
        if (countdown) {
            clearInterval(countdown);
        }
    }

    timerInterval = () => {
        const { elapseTime } = this.state;
        if (elapseTime <= 1 && this.isOk()) {
            console.log('submit');
            this.handleSubmit();
        }
        this.setState({ elapseTime: elapseTime - 1 });
    };

    handleChangeProces = (event) => {
        this.setState({ products: event });
    };

    handleChangeMachine = (event) => {
        this.setState({ machine: event });
    };

    handleMinus = (event) => {
        const { units, machines } = this.state;
        const value = parseInt(units, 10) - 1;
        this.UpdateMachines(machines, value);

        if (this.state.units > 0) {
            this.setState({ units: value });
        }
    };

    handlePlus = (event) => {
        const { units, machines } = this.state;
        const value = parseInt(units, 10) + 1;
        this.UpdateMachines(machines, value);
        this.setState({ units: value });
    };


    handleChangeClick = (add) => (event) => {
        const { units, machines } = this.state;
        const value = parseInt(units.toString().concat(add), 10);
        this.UpdateMachines(machines, value);
        this.setState({ units: value });
    };

    handleRemoveUnits = (event) => {
        const { machines } = this.state;
        this.UpdateMachines(machines, 0);
        this.setState({ units: 0 });
    }

    handleChange = (event) => {
        const { machines } = this.state;
        const value = parseInt(event.target.value, 10);
        this.UpdateMachines(machines, value);

        this.setState({ [event.target.name]: event.target.value });
    };

    handleOpen = (event) => {
        console.log('handleOpen');

        const { countdown } = this.state;
        if (countdown) {
            clearInterval(countdown);
        }
        this.setState({ elapseTime: undefined, countdown: undefined });
    };

    handleSubmit = (event) => {
        const { product, units, machine, countdown } = this.state;
        this.props
            .production({
                idLocal: this.props.id,
                idProduccion: product.id,
                cantidad: units,
                idMaquina: machine.value,
            })
            .then(() => this.props.handleClose('run', false))
            .catch((error) => this.props.handleClose('run', error.message));
        clearInterval(countdown);
        this.setState({ open: false, countdown: false });
    };

    handleRemove = (event) => {
        const { product, units, machine, countdown } = this.state;
        this.props
            .removeproduction({
                idLocal: this.props.id,
                idProduccion: product.id,
                cantidad: units,
                idMaquina: machine.value,
            })
            .then(() => this.props.handleClose('run', false))
            .catch((error) => this.props.handleClose('run', error.message));
        clearInterval(countdown);
        this.setState({ open: false, countdown: false });
    };

    isOk = () => {
        const { product, units, machine } = this.state;
        return product && units > 0 && machine;
    };

    render() {
        const { product, machine, list, units, elapseTime, open, loaded, enabled } = this.state;
        const { handleClose, intl } = this.props;
        const disabled = !this.isOk();

        return (
            <Dialog
                onClose={() => handleClose('run', false)}
                aria-labelledby="customized-dialog-title"
                open={open}
                disableBackdropClick
                classes={{
                    paper: 'xhef_waste_popup',
                }}
            >
                <div className="flex_full_column">
                    <div className="flex_auto_row xhef_waste_popup_header align_center">
                        <IconButton
                            aria-label="Close"
                            className={''}
                            onClick={() => handleClose('run', false)}
                        >
                            <BlueCloseIcon />
                        </IconButton>
                        <div className="flex_full_row center barlowsemicondensed_bold">
                            {intl.formatMessage({ id: 'xhef_popup_runcommand_title' }) +
                                ' "' +
                                product.nomProducto +
                                '"'}
                        </div>
                    </div>
                    <div className="flex_auto_row">
                        <div className="flex_full_column">
                            {!!elapseTime && (
                                <div className="flex_auto_row bg_golden_yellow align_center padding_borders barlow_regular">
                                    <div className="flex_full_row barlow_regular_title c_dark_grey_blue">
                                        {intl.formatMessage({
                                            id: 'xhef_popup_runcommand_warning_label',
                                        })}
                                    </div>
                                    <div className="flex_auto_row barlowcondensed_light_percentage nowrap margin_right_12 c_dark_grey_blue">
                                        {elapseTime + ' ' + intl.formatMessage({ id: 'sec' })}
                                    </div>
                                    <Alarm className="c_white" />
                                </div>
                            )}
                            {(loaded && (!list || list.length === 0)) && (
                                <div className="flex_auto_row bg_lipstick align_center padding_borders barlow_regular">
                                    <div className="flex_full_row barlow_regular_title c_white">
                                        {intl.formatMessage({
                                            id: 'xhef_popup_runcommand_machins_not_available',
                                        })}
                                    </div>
                                    <Error className="c_white" />
                                </div>
                            )}

                            <div className="flex_auto_column padding_borders">
                                <div className="flex_full_row margin_top_32 align_center">
                                    <TextField
                                        required
                                        fullWidth
                                        //disabled={!enabled}
                                        name={'units'}
                                        id={'units'}
                                        label={intl.formatMessage({
                                            id: 'xhef_popup_waste_units_title',
                                        })}
                                        disabled={true}
                                        value={units}
                                        type="number"
                                        inputProps={{
                                            className: 'barlowcondensed_regular c_black',
                                            pattern: '[0-9]*',
                                            style: { textAlign: 'center' },
                                        }}
                                        onChange={this.handleChange}
                                        className="text_align_center"
                                    />
                                </div>
                                {/*
                                <div className="flex_full_row margin_top_32 align_center">
                                    <Button
                                        onClick={this.handleMinus.bind(this)}
                                        variant="contained"
                                        disabled={units <= 0} // || !enabled}
                                        className={
                                            'flex_full_row bg_white padding_borders xhef_waste_popup_button_negative'
                                        }
                                        classes={{
                                            disabled: 'xhef_waste_popup_button_negative_disabled',
                                        }}
                                    >
                                        <MinusIcon className={units > 0 ? 'c_bluish' : 'c_white'} />
                                    </Button>
                                    <Button
                                        onClick={this.handlePlus.bind(this)}
                                        variant="contained"
                                        //disabled={!enabled}
                                        className={
                                            'flex_full_row bg_pea padding_borders xhef_waste_popup_button_positive'
                                        }
                                        classes={{
                                            disabled: 'xhef_waste_popup_button_negative_disabled',
                                        }}
                                    >
                                        <AddIcon className="c_white" />
                                    </Button>
                                </div>
                                */}
                                <div className="flex_auto_row ">
                                    <div className="flex_full_column">
                                        <div className="flex_full_row center margin_top_32 ">
                                            <Button
                                                onClick={this.handleChangeClick(0)}
                                                color="primary"
                                                variant="outlined"
                                                className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                            >
                                                0
                                                </Button>
                                            <Button
                                                onClick={this.handleChangeClick(1)}
                                                color="primary"
                                                variant="outlined"
                                                className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                            >
                                                1
                                                </Button>
                                            <Button
                                                onClick={this.handleChangeClick(2)}
                                                color="primary"
                                                variant="outlined"
                                                className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                            >
                                                2
                                                </Button>
                                            <Button
                                                onClick={this.handleChangeClick(3)}
                                                color="primary"
                                                variant="outlined"
                                                className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                            >
                                                3
                                                </Button>
                                            <Button
                                                onClick={this.handleChangeClick(4)}
                                                color="primary"
                                                variant="outlined"
                                                className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                            >
                                                4
                                                </Button>
                                        </div>
                                        <div className="flex_full_row center margin_top_32 ">
                                            <Button
                                                onClick={this.handleChangeClick(5)}
                                                color="primary"
                                                variant="outlined"
                                                className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                            >
                                                5
                                                </Button>
                                            <Button
                                                onClick={this.handleChangeClick(6)}
                                                color="primary"
                                                variant="outlined"
                                                className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                            >
                                                6
                                                </Button>
                                            <Button
                                                onClick={this.handleChangeClick(7)}
                                                color="primary"
                                                variant="outlined"
                                                className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                            >
                                                7
                                                </Button>
                                            <Button
                                                onClick={this.handleChangeClick(8)}
                                                color="primary"
                                                variant="outlined"
                                                className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                            >
                                                8
                                                </Button>
                                            <Button
                                                onClick={this.handleChangeClick(9)}
                                                color="primary"
                                                variant="outlined"
                                                className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                            >
                                                9
                                                </Button>
                                        </div>
                                    </div>
                                    <Button
                                        onClick={this.handleRemoveUnits}
                                        color="primary"
                                        variant="outlined"
                                        className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6 margin_top_32"
                                    >
                                        {
                                            intl.formatMessage({
                                                id: 'remove',
                                            })
                                        }
                                    </Button>
                                </div>
                                <div className="flex_auto_row align_center margin_top_32">
                                    <SelectInput
                                        defaultValue={machine}
                                        placeHolder={intl.formatMessage({
                                            id: 'xhef_popup_command_machine_title',
                                        })}
                                        isNotSearchable
                                        options={
                                            list && list.length > 0
                                                ? list.map((m) => {
                                                    return { value: m.id, label: m.nombre };
                                                })
                                                : []
                                        }
                                        onOpen={this.handleOpen}
                                        onChange={this.handleChangeMachine}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex_auto_row center xhef_waste_popup_footer">

                        {!enabled &&
                            <Button
                                disabled={disabled}
                                variant="contained"
                                color="secondary"
                                className={'flex_full_row barlow_semibold padding_borders margin_right_6'}
                                onClick={this.handleRemove}
                            >
                                {intl.formatMessage({ id: 'xhef_popup_runcommand_remove_button_title' }) +
                                    ' ' +
                                    product.nomProducto}
                            </Button>
                        }
                        <Button
                            disabled={disabled}
                            variant="contained"
                            color="primary"
                            className={'flex_full_row barlow_semibold padding_borders margin_left_6 '}
                            onClick={this.handleSubmit}
                        >
                            {intl.formatMessage({ id: 'xhef_popup_runcommand_button_title' }) +
                                ' ' +
                                product.nomProducto}
                        </Button>

                    </div>
                </div>
            </Dialog>
        );
    }
}

CommandPopup.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(CommandPopup);



// WEBPACK FOOTER //
// ./src/components/complex/xhef/RunCommandPopup.js